import "./AppointmentsInjuryDetailsFormViewEditComponent.scss";
import BackComponent from "../../../../shared/components/back/BackComponent";
import React, {useCallback, useEffect} from "react";
import CardComponent from "../../../../shared/components/card/CardComponent";
import {useNavigate, useParams} from "react-router-dom";
import {CommonService} from "../../../../shared/services";
import ClientInjuryDetailsScreen from "../../../client-registration/client-injury-details/ClientInjuryDetailsScreen";
import LoaderComponent from "../../../../shared/components/loader/LoaderComponent";
import StatusCardComponent from "../../../../shared/components/status-card/StatusCardComponent";

interface AppointmentsInjuryDetailsFormViewEditComponentProps {
    formMode?: 'view' | 'edit';
}

const AppointmentsInjuryDetailsFormViewEditComponent = (props: AppointmentsInjuryDetailsFormViewEditComponentProps) => {
    const params = useParams<{ formId: string, appointmentId: string }>();
    const {formId, appointmentId} = params;
    const [injuryDetails, setInjuryDetails] = React.useState<any[]>([]);
    const [isInjuryDetailsLoading, setIsInjuryDetailsLoading] = React.useState<boolean>(false);
    const [isInjuryDetailsLoadingFailed, setIsInjuryDetailsLoadingFailed] = React.useState<boolean>(false);
    const [isInjuryDetailsLoaded, setIsInjuryDetailsLoaded] = React.useState<boolean>(false);
    const navigate = useNavigate();

    const handleBackNavigation = useCallback(() => {
        navigate('/appointments/' + appointmentId)
    }, [navigate, appointmentId])


    const getInjuryDetails = useCallback((formId: string) => {
        setIsInjuryDetailsLoading(true);
        setIsInjuryDetailsLoadingFailed(false);
        setIsInjuryDetailsLoaded(false);
        CommonService._appointment.getInjuryDetails(formId)
            .then((response: any) => {
                setInjuryDetails(response.data);
                setIsInjuryDetailsLoaded(true);
                setIsInjuryDetailsLoadingFailed(false);
                setIsInjuryDetailsLoading(false)

            }).catch((error: any) => {
            setInjuryDetails([]);
            setIsInjuryDetailsLoaded(false);
            setIsInjuryDetailsLoadingFailed(true);
            setIsInjuryDetailsLoading(false)
        })

    }, []);

    useEffect(() => {
        if (formId) {
            getInjuryDetails(formId);
        }
    }, [getInjuryDetails, formId]);

    const handleSubmit = useCallback((values: any) => {
        setInjuryDetails(values);
    }, []);

    return (
        <div className={'appointments-injury-details-form-view-edit-component appointment-form'}>
            <div className={'appointments-view-edit-form-header'}>
                <BackComponent onClick={() => {
                    handleBackNavigation()
                }}/>
            </div>
            {
                isInjuryDetailsLoading && <LoaderComponent/>
            }
            {
                isInjuryDetailsLoadingFailed &&
                <StatusCardComponent title={'Failed to load form details'}/>
            }
            {
                isInjuryDetailsLoaded &&
                <CardComponent>
                    <ClientInjuryDetailsScreen formId={formId} initialValues={injuryDetails}
                                               onSubmitComplete={handleSubmit} appointmentId={appointmentId}/>
                </CardComponent>
            }
        </div>
    );

};

export default AppointmentsInjuryDetailsFormViewEditComponent;
